import { mapGetters } from "vuex";

export const hasSomeUserGroupMixin = {
  computed: {
    ...mapGetters(["loggedUser"]),

    isAdmin() {
      const currentUserGroups = this.loggedUser?.group;
      return currentUserGroups?.includes("admin");
    },

    isFinancial() {
      const currentUserGroups = this.loggedUser?.group;
      return currentUserGroups?.includes("financial");
    },

    isSalesPartner() {
      const currentUserGroups = this.loggedUser?.group;
      return (
        currentUserGroups?.includes("sales_partner") ||
        currentUserGroups?.includes("sales_partner_management")
      );
    },

    isSalesManagement() {
      const currentUserGroups = this.loggedUser?.group;
      return currentUserGroups?.includes("sales_management");
    },

    isCustomerCareLeader() {
      const currentUserGroups = this.loggedUser?.group;
      return currentUserGroups.includes("customer_care_leader");
    },

    isCollection() {
      const currentUserGroups = this.loggedUser?.group;
      return currentUserGroups.includes("collection");
    },

    isExternalCollection() {
      const currentUserGroups = this.loggedUser?.group;
      return currentUserGroups.includes("external_collection");
    },

    canChooseUniqueBilling() {
      const currentUserGroups = this.loggedUser?.group;
      return (
        currentUserGroups?.includes("sales_management") ||
        currentUserGroups?.includes("sales") ||
        currentUserGroups?.includes("admin")
      );
    },
  },
};
